import { render } from "./ResourcesGoal2b.vue?vue&type=template&id=c0042eea"
import script from "./ResourcesGoal2b.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal2b.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__